export default __webpack_public_path__ + "static/media/loading.cf085d71.svg";